import React from 'react';
import {useSearch} from "../../model/useSearch";
import {useProductSearchStore} from "../../model/store";
import styled from "styled-components";
import Button from "../../../../shared/ui/button/Button";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";
import {useInfiniteScroll} from "../../../../shared/hook/useInfiniteScroll";

const StyledProductMore = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 32px;

    button {
        min-width: 240px;
        max-width: 240px;
    }
`


/**
 * ProductLoadMore. Подгрузка элементов
 */
const ProductLoadMore = () => {
    const isLoading = useProductSearchStore(state => state.isLoading);
    const search = useProductSearchStore(state => state.search);
    const filterState = useProductSearchStore(state => state.filter.state);
    const metaPagination = useProductSearchStore(state => state.metaPagination);
    const {fetchingSearch} = useSearch();
    const totalPage = Math.ceil(metaPagination.count / metaPagination.limit);
    const currentPage = metaPagination.start_from / metaPagination.limit;
    const nextPage = currentPage + 1;

    const hasMore = nextPage < totalPage;
    const fetchMoreProducts = () => {
        fetchingSearch({
            searchTerm: search.token,
            startIndex: (nextPage * metaPagination.limit),
            filterState: filterState ?? {},
            isLoadMore: true
        });
    }
    const loadMoreRef =
        useInfiniteScroll(() => {
            // Не запускаем подгрузку, пока выполняется предыдущая
            if(isLoading) return
            fetchMoreProducts(); // Загружаем дополнительные товары
        }, hasMore, isLoading);

    if (nextPage >= totalPage) {
        return null
    }


    return (
        isLoading ? <div style={{height: '1px'}}></div>

            : <div className="" ref={loadMoreRef} style={{height: '1px'}}></div>
    );
};

export default ProductLoadMore;